<template>
  <div class="applyDetail">
    <navigate-header hasBack="true" :title="navigateTitle" v-if="hasHeader" :navigateStyle="navigateStyle">
      <div slot="rightBtn" class="btn right-btn" @click="cancelOrder">
        取消办理
      </div>
    </navigate-header>
    <section class="page-content">
      <ul class="form">
        <li class="form-item">
          <span class="label">车牌号码</span>
          <span class="disable">{{newApplyInfo.plate_no}}</span>
        </li>
        <li class="form-item">
          <span class="label">发行方</span>
          <span class="disable">{{currentCard.issuer_name}}</span>
        </li>
        <li class="form-item">
          <span class="label">收货人</span>
          <span class="disable">{{newApplyInfo.send_name}}</span>
        </li>
        <li class="form-item">
          <span class="label">手机号码</span>
          <span class="disable">{{newApplyInfo.send_phone}}</span>
        </li>
        <li class="form-item">
          <label for="send_area">收货地址</label>
          <button id="send_area" class="send_area" :class="{'gray': !formData.send_area}" @click="choosePicker('send_area')">
            <span>{{formData.send_area || '地区信息（必填）'}}</span>
            <i class="iconfont etc-icon-arrow-right"></i>
          </button>
        </li>
        <li no-border class="form-item textarea">
          <label for="send_address">详细地址</label>
          <textarea name="send_address" id="send_address"
                    maxlength="26"
                    :class="{'line2': addressLine2}"
                    placeholder="街道门牌信息（最多25字）"
                    @input="addressInput"
                    @change="formChange('send_address')"
                    v-model="formData.send_address"></textarea>
        </li>
      </ul>
    </section>
    <area-picker ref="picker" @confirmAreaPicker="confirmAreaPicker($event)"></area-picker>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// components
import AreaPicker from '@/components/cool.areaPicker'
import NavigateHeader from '@/components/cool.navigateHeader'
// store
import {mapState, mapMutations} from 'vuex'
// config
import APP from '@/config/app.config'
// apis
import NewApplyApi from '@/api/newApply.api'

let customData = {
  pickerIndex: {send_area: [0, 0, 0]}
}

export default {
  name: 'applyDetail',
  mixins: [FunMixin],
  components: {
    NavigateHeader,
    AreaPicker
  },
  data() {
    return {
      addressLine2: '',
      formData: ''
    }
  },
  computed: {
    ...mapState([
      'newApplyInfo',
      'currentCard'
    ])
  },
  methods: {
    choosePicker(key) {
      this.$refs.picker.$emit('showAreaPicker', {key, index: customData.pickerIndex[key]})
    },
    addressInput() {
      const address = this.formData.send_address = this.formData.send_address.replace(APP.FILTER_ADDRESS_REG, ($1) => '')
      if (address.length > 14) {
        this.addressLine2 = true
        this.formData.send_address = address.substr(0, 14) + '\n' + address.substring(14, address.length)
      } else {
        this.addressLine2 = false
      }
    },
    async formChange(key) {
      // let params = {}
      // params[key] = this.formData[key]
      try {
        await NewApplyApi.modifyAddress(this.formData)
        this.setNewApplyInfo(Object.assign({}, this.formData))
      } catch (e) {
      }
    },
    async confirmAreaPicker(e) {
      this.formData[e.key] = e.value
      customData.pickerIndex[e.key] = e.index
      this.$forceUpdate()
      this.formChange('send_area')
    },
    cancelOrder() {
      this.m_goPages('cancelOrder')
    },
    ...mapMutations([
      'setNewApplyInfo'
    ])
  },
  mounted() {
    this.formData = {
      send_name: this.newApplyInfo.send_name,
      send_phone: this.newApplyInfo.send_phone,
      send_area: this.newApplyInfo.send_area,
      send_address: this.newApplyInfo.send_address
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.applyDetail {
  .page-content {
    background-color: #fff;
    .form{
      padding: 0 40px;
      .form-item{
        height: 100px;
        @extend %flex-center-start;
        border-bottom: 1px solid #eeeeee;
        .label, label{
          width: 180px;
          flex-shrink: 0;
          font-size: 30px;
        }
        .disable{
          font-size: 30px;
          color: #999999;
        }
        .send_area{
          font-size: 30px;
          flex-grow: 1;
          padding: 10px 0;
          @extend %flex-space-between;
          i{
            font-size: 30px;
            color: #999999;
          }
          &.gray {
            color: $placeholder-color;
            font-size: $placeholder-size;
            line-height: $placeholder-line-height;
          }
        }
        &.textarea {
          font-size: 30px;
          height: 140px;
          textarea {
            flex-grow: 1;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            box-sizing: content-box;
            @include placeholder(0, 30px, 50px);
            &.line2{
              height: 100px;
            }
          }
        }
      }
    }
  }
  .page-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 10px 55px 30px;
    button{
      color: #999999;
      border-color: #999999;
    }
  }
}
</style>
